exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "code{color:#1f2937}input[type=color]{-webkit-appearance:none;border-color:transparent;width:50px;height:24px;border-radius:4px}input[type=color]::-webkit-color-swatch-wrapper{padding:0}input[type=color]::-webkit-color-swatch{border:none;border-radius:4px}", ""]);

// exports
